// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { boolean, string, nullOrUndefined, number } from "@altostra/type-validations/lib/primitives";

export const isCanvasResult = objectOf({
  workflow: objectOf({
    workflow_name: string,
    workflow_description: nullOrUndefined,
    id: string,
    api_workflow_id: string,
    app_group_id: string,
    context_property_names_info: objectOf({
      names: arrayOf(nullOrUndefined),
    }),
    segments_data_array: arrayOf(
      arrayOf(
        objectOf({
          id: string,
          name: string,
          app_group_id: string,
          is_archived: boolean,
          is_global_control: boolean,
          non_retargetable: boolean,
        })
      )
    ),
    filters: arrayOf(nullOrUndefined),
    enabled: boolean,
    currently_sending: boolean,
    match_more_than_once: boolean,
    can_match_again_after_seconds: number,
    match_again_is_max_duration: boolean,
    maximum_duration: number,
    schedule_type: string,
    schedule_data: maybe(
      objectOf({
        recurring: boolean,
      }),
      true
    ),
    trigger_schedule_data: nullOrUndefined,
    max_recipients: nullOrUndefined,
    time_rate_limit: nullOrUndefined,
    max_recipients_is_global: boolean,
    created: objectOf({
      c: nullOrUndefined,
      fm: nullOrUndefined,
      time: number,
      name: string,
      d_id: string,
    }),
    last_edit: objectOf({
      c: nullOrUndefined,
      fm: nullOrUndefined,
      time: number,
      name: string,
      d_id: string,
    }),
    is_archived: boolean,
    is_draft: boolean,
    version: string,
    draft_is_set_to_send_immediately: boolean,
    conversion_behaviors: arrayOf(nullOrUndefined),
    tag_names: arrayOf(nullOrUndefined),
    conversion_filter_descriptions: arrayOf(string),
    variations: arrayOf(
      objectOf({
        id: string,
        name: string,
        first_step_ids: arrayOf(nullOrUndefined),
        first_canvas_step_id: string,
        send_percentage: number,
        is_control: boolean,
        api_variation_id: string,
      })
    ),
    ignore_global_frequency_capping: boolean,
    exclude_from_global_frequency_count: boolean,
    recipient_subscription_state: number,
    steps: nullOrUndefined,
    step_ids: arrayOf(string),
    territory_ids: arrayOf(nullOrUndefined),
    total_sent: number,
    seed_exclude_already_sent_not_updated: boolean,
    automatic_distribution_optimization: boolean,
    distribution_optimization_complete: nullOrUndefined,
    priority_bucket: nullOrUndefined,
    quiet_time_data: objectOf({
      quiet_start_hour: nullOrUndefined,
      quiet_start_minute: nullOrUndefined,
      quiet_end_hour: nullOrUndefined,
      quiet_end_minute: nullOrUndefined,
      has_quiet_time: boolean,
      send_after_quiet_time: boolean,
    }),
    has_advanced_to_grid_view: boolean,
    targets_android: boolean,
    classic_migrated_workflow_id: nullOrUndefined,
    exit_criteria: objectOf({
      exit_event: nullOrUndefined,
    }),
    changelog_count: number,
  }),
  funnel_report: nullOrUndefined,
  retention_report: nullOrUndefined,
});
